import { Component, Input, OnInit } from '@angular/core';
import { DocumentsPAC } from '@shared/model';

@Component({
    selector: 'document-details',
    templateUrl: './document-details.component.html',
    styleUrls: ['./document-details.component.scss'],
    standalone: false
})
export class DocumentDetailsComponent implements OnInit {
  @Input() documents!: DocumentsPAC[];
  @Input() isPASComplete: boolean;

  cols: object[] = [];

  ngOnInit(): void {
    this.cols = [
      { header: 'File Name', width: '25%' },
      { header: 'Document Type', width: '25%' },
      { header: 'Description', width: '25%' },
      { header: 'File Size', width: '25%' },
    ];
  }
}
